import React, { useContext, useState, useLayoutEffect} from "react";
import WebServiceContext from "../WebService/ServiceContext";

type ImgLoaderProp = {
    ActID:string
}

const ImgLoader = (prop:ImgLoaderProp) => {
    
    const ws = useContext(WebServiceContext)
    const [pic, setPic]=useState<string|undefined>(undefined) 
        
    useLayoutEffect(()=>{
        ws.WebService.asyncGetActCover(prop.ActID).then((res: any) => {
            //setPic("data:image/png;base64," + res)
            //console.log(res)

            if (process.env.NODE_ENV !== "development") {                
                setPic(res)
            }else{
            }
        })
        return
    },[prop])


    if (process.env.NODE_ENV !== "development") {
        return (
            <img src={pic}/>
        )
    }else{
        return (
            <div>TEST</div>
        )
    }
    
}

export default ImgLoader
